import { Component } from '@angular/core';

@Component({
  selector: 'app-workshops26',
  templateUrl: './workshops.component.html',
  styleUrl: './workshops.component.css'
})
export class Workshops26Component {

}
